import { getRoute } from "@utils/route";

export const ABOUT_US_PAGE_URL = '/about-us';

export const routeAboutUsPage = () => getRoute(ABOUT_US_PAGE_URL);
